import { type ChangeEvent, useState, useEffect, useMemo } from 'react'

import { Button, Modal, TextArea } from '@/shared'
import { type IAddFaqDto } from '@App/types/faqTypes'

import style from './AddFaqModal.module.scss'

interface IProps {
    show: boolean
    onClose: () => void
    postFaq: (dto: IAddFaqDto) => void
    count: number
}

export const AddFaqModal = (props: IProps) => {
    const { show, onClose, postFaq, count } = props

    const init = useMemo(() => ({ header: '', title: '', sequence: count }), [count])
    const [state, setState] = useState<IAddFaqDto>(init)
    useEffect(() => setState(init), [init])

    const onPostFaq = () => {
        postFaq(state)
        onClose()
    }

    const actions = [{ title: 'Добавить', callback: onPostFaq, disabled: !state.title || !state.header }]

    const onChangeValue = (prop: 'header' | 'title', value: string) => {
        setState((prev) => ({ ...prev, [prop]: value }))
    }

    const onChangeHeader = (e: ChangeEvent<HTMLTextAreaElement>) => onChangeValue('header', e.target.value)
    const onChangeTitle = (e: ChangeEvent<HTMLTextAreaElement>) => onChangeValue('title', e.target.value)

    return (
        <Modal show={show} onClose={onClose}>
            <div className={style.container}>
                <div className={style.header}>
                    <span>Новый Вопрос</span>
                </div>
                <div className={style.fields}>
                    <TextArea
                        scrollHeight={60}
                        placeholder='Укажите вопрос'
                        value={state.header}
                        onChange={onChangeHeader}
                    />
                    <TextArea
                        scrollHeight={60}
                        placeholder='Укажите ответ'
                        value={state.title}
                        onChange={onChangeTitle}
                    />
                </div>
                <div className={style.control}>
                    {actions.map(({ title, callback, disabled }) => (
                        <Button key={title} onClick={callback} disabled={disabled}>
                            {title}
                        </Button>
                    ))}
                </div>
            </div>
        </Modal>
    )
}
